
import { cn } from '@univdiam/ui/lib/utils';

type MetalButtonProps = {
  label: string;
  colorClass: string;
  textColorClass: string;
  isSelected: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export const MetalButton: React.FC<MetalButtonProps> = ({ label, colorClass, textColorClass, isSelected, onClick, disabled }) => {
  const displayLabel = label.toLowerCase() === 'plt' ? 'Plt' : label;

  return (
    <button
      type="button"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={cn(
        'w-10 h-10 rounded-full flex items-center justify-center text-caption2 font-semibold shadow-xs transition-colors duration-200',
        disabled ? 'bg-muted opacity-40 shadow-none cursor-not-allowed' : colorClass,
        isSelected && !disabled ? 'ring-2 ring-offset-2 ring-primary shadow-md' : !disabled && 'hover:shadow-md'
      )}
      aria-label={displayLabel}
    >
      <span className={disabled ? 'text-muted-foreground' : textColorClass}>
        {displayLabel}
      </span>
    </button>
  );
};
